import { Controller } from "../../../Controller";
import { ListarUsuariosSpeDoProdutoService } from "../../../../Services/Geral/Produtos/ProdutoSpeUsuario/ProdutoSpeUsuarioServices";

export async function ListarUsuariosSpeDoProdutoController(idProduto: number) {
    return Controller(ListarUsuariosSpeDoProdutoService(idProduto));
}
